export default __webpack_public_path__ + "static/video-079ac26896cdbff606ec9f317f7fed2c.gif";